import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/external-influencer`;
export const byRealEstateGroupIdUri = `${baseUri}/:realEstateGroupId`;
export const publishUri = `${byRealEstateGroupIdUri}/publish`;
export const updateCoverUri = `${byRealEstateGroupIdUri}/cover`;
export const byUrlUri = `${baseUri}/:url`;
export const featureScopesConfigUri = `${byRealEstateGroupIdUri}/feature-scopes-config`;
